import B2B from "../pages/B2b";
import Home from "../pages/Home";
import Users from "../pages/Users";
import Report from "../pages/Report";
import Rating from "../pages/Rating";
import Content from "../pages/Content";
import Tickets from "../pages/Tickets";
import Calendar from "../pages/Calendar";
import Login from "../pages/Login/Login";
import Teachers from "../pages/Teachers";
import Languages from "../pages/Languages";
import Countries from "../pages/Countries";
import NoRoute from "../pages/NoRoute/NoRoute";
import CheckoutSite from "../pages/CheckoutSite";
import Student from "../pages/StudentManagement";
import NewRating from "../pages/Rating/NewRating";
import ReportDetails from "../pages/ReportDetails";
import PushGenerator from "../pages/PushGenerator";
import ForgetPass from "../pages/Login/ForgetPass";
import ManageAccount from "../pages/ManageAccount";
import EditUsers from "../pages/Users/NewUsers.js";
import EconomicGroup from "../pages/EconomicGroup";
import HomeAffiliate from "../pages/HomeAffiliate";
import DynamicContent from "../pages/DynamicContent";
import DemoClass from "../pages/DemoClass/DemoClass";
import PlansAndPrices from "../pages/PlansAndPrices";
import NewTickets from "../pages/Tickets/NewTickets";
import SignUpAffiliate from "../pages/SignUpAffiliate";
import CustomerService from "../pages/CustomerService";
import ManageAffiliate from "../pages/ManageAffiliate";
import AutoReviewReport from "../pages/AutoReviewReport";
import DemoClasses from "../pages/DemoClass/DemoClasses";
import Parameterization from "../pages/Parameterization";
import TeachersManage from "../pages/Teachers/NewTeacher";
import ClassRating from "../pages/ClassRating/ClassRating";
import NewTicket from "../pages/CustomerService/NewTicket";
import NewLanguages from "../pages/Languages/NewLanguages";
import NewCountries from "../pages/Countries/NewCountries";
import SettingsAffiliate from "../pages/SettingsAffiliate";
import Ticket from "../pages/CustomerService/TicketDetails";
import ClassDetails from "../pages/ClassDetails/ClassDetails";
import ManageAccountPlans from "../pages/ManageAccount/Plans";
import Notifications from "../pages/Notifications/Notifications";
import PlansAndPricesForm from "../pages/PlansAndPrices/add-new";
import GoogleCallback from "../pages/Integrations/GoogleCallback";
import DetailAffiliate from "../pages/ManageAffiliate/DetailAffiliate";
import NewEconomicGroup from "../pages/EconomicGroup/NewEconomicGroup";
import DetailStudents from "../pages/StudentManagement/DetailStudents";
import ManageAccountLevelScore from "../pages/ManageAccount/LevelScore";
import ManageAccountNotification from "../pages/ManageAccount/Notification";
import NotificationsSettings from "../pages/Notifications/NotificationsSettings";

export const nav = [
  { path: "/home", name: "Home", element: <Home />, isPrivate: true },
  { path: "/users", name: "Users", element: <Users />, isPrivate: true },
  { path: "/report", name: "Report", element: <Report />, isPrivate: true },
  { path: "/rating", name: "Rating", element: <Rating />, isPrivate: true },
  { path: "/content", name: "Content", element: <Content />, isPrivate: true },
  { path: "/tickets", name: "Tickets", element: <Tickets />, isPrivate: true },
  { path: "/teachers", name: "Teachers", element: <Teachers />, isPrivate: true },
  { path: "/calendar", name: "Calendar", element: <Calendar />, isPrivate: true },
  { path: "/users/new", name: "NewUsers", element: <EditUsers />, isPrivate: true },
  { path: "/countries", name: "Countries", element: <Countries />, isPrivate: true },
  { path: "/languages", name: "Languages", element: <Languages />, isPrivate: true },
  { path: "/users/:id", name: "DetailUsers", element: <EditUsers />, isPrivate: true },
  { path: "/manage-student", name: "Students", element: <Student />, isPrivate: true },
  { path: "/tickets/new", name: "NewTickets", element: <NewTickets />, isPrivate: true },
  { path: "/tickets/:id", name: "DetailTickets", element: <NewTickets />, isPrivate: true },
  { path: "/class-rating", name: "ClassRating", element: <ClassRating />, isPrivate: true },
  { path: "/affiliate", name: "homeAffiliate", element: <HomeAffiliate />, isPrivate: true },
  { path: "/rating-student/new", name: "NewRating", element: <NewRating />, isPrivate: true },
  { path: "/countries/new", name: "NewCountries", element: <NewCountries />, isPrivate: true },
  { path: "/teachers/new", name: "NewTeachers", element: <TeachersManage />, isPrivate: true },
  { path: "/languages/new", name: "Newlanguages", element: <NewLanguages />, isPrivate: true },
  { path: "/rating-student/:id", name: "DetailRating", element: <NewRating />, isPrivate: true },
  { path: "/notifications", name: "Notifications", element: <Notifications />, isPrivate: true },
  { path: "/push-generator", name: "PushGenerator", element: <PushGenerator />, isPrivate: true },
  { path: "/settings-affiliate", name: "Users", element: <SettingsAffiliate />, isPrivate: true },
  { path: "/countries/:id", name: "DetailCountries", element: <NewCountries />, isPrivate: true },
  { path: "/economic-group", name: "EconomicGroup", element: <EconomicGroup />, isPrivate: true },
  { path: "/teachers/:id", name: "DetailTeachers", element: <TeachersManage />, isPrivate: true },
  { path: "/class-details/:id", name: "ClassRating", element: <ClassDetails />, isPrivate: true },
  { path: "/manage-account", name: "ManageAccount", element: <ManageAccount />, isPrivate: true },
  { path: "/languages/:id", name: "DetailLanguages", element: <NewLanguages />, isPrivate: true },
  { path: "/report-details", name: "ReportDetails", element: <ReportDetails />, isPrivate: true },
  { path: "/auto-review-report", name: "Content", element: <AutoReviewReport />, isPrivate: true },
  { path: "/dynamic-content", name: "DynamicContent", element: <DynamicContent />, isPrivate: true },
  { path: "/manage-affiliate", name: "ManageAffiliate", element: <ManageAffiliate />, isPrivate: true },
  { path: "/manage-student/:id", name: "DetailStudents", element: <DetailStudents />, isPrivate: true },
  { path: "/customer-service", name: "CustomerService", element: <CustomerService />, isPrivate: true },
  { path: "/customer-service/new", name: "CustomerServiceNew", element: <NewTicket />, isPrivate: true },
  { path: "/parameterization", name: "Parameterization", element: <Parameterization />, isPrivate: true },
  { path: "/manage-affiliate/:id", name: "DetailAffiliate", element: <DetailAffiliate />, isPrivate: true },
  { path: "/economic-group/new", name: "NewEconomicGroup", element: <NewEconomicGroup />, isPrivate: true },
  { path: "/economic-group/:id", name: "DetailEconomicGroup", element: <NewEconomicGroup />, isPrivate: true },
  { path: "/manage-account/plan", name: "ManageAccountPlans", element: <ManageAccountPlans />, isPrivate: true },
  { path: "/customer-service/ticketDetail", name: "CustomerServiceDetais", element: <Ticket />, isPrivate: true },
  {
    path: "/notifications-settings",
    name: "NotificationsSettings",
    element: <NotificationsSettings />,
    isPrivate: true,
  },
  {
    path: "/manage-account/levelscore",
    name: "ManageAccountLevelScore",
    element: <ManageAccountLevelScore />,
    isPrivate: true,
  },
  {
    path: "/manage-account/notification",
    name: "ManageAccountNotification",
    element: <ManageAccountNotification />,
    isPrivate: true,
  },
  {
    path: "/integrations/google/callback",
    name: "GoogleCalendarCallback",
    element: <GoogleCallback />,
    isPrivate: true,
  },
  {
    path: "/calendar/oauth/google/callback",
    name: "GoogleCalendarCallbackLegacy",
    element: <GoogleCallback />,
    isPrivate: true,
  },
  {
    path: "/b2b",
    name: "B2B",
    element: <B2B />,
    isPrivate: true,
  },
  {
    path: "/b2b/coupons",
    name: "B2BCoupons",
    element: <B2B />,
    isPrivate: true,
  },
  {
    path: "/demo-class",
    name: "DemoClasses",
    element: <DemoClasses />,
    isPrivate: true,
  },
  {
    path: "/demo-class/new",
    name: "DemoClassForm",
    element: <DemoClass />,
    isPrivate: true,
  },
  {
    path: "/plans-and-prices",
    name: "PlansAndPrices",
    element: <PlansAndPrices />,
    isPrivate: true,
  },
  {
    path: "/plans-and-prices/new",
    name: "PlansAndPricesDetails",
    element: <PlansAndPricesForm />,
    isPrivate: true,
  },
  {
    path: "/plans-and-prices/:id",
    name: "PlansAndPricesDetails",
    element: <PlansAndPricesForm />,
    isPrivate: true,
  },
  {
    path: "/demo-class/:id",
    name: "DemoClassEdit",
    element: <DemoClass />,
    isPrivate: true,
  },
  { path: "*", name: "NotFound", element: <NoRoute />, isPrivate: true },
  { path: "/checkout", name: "CheckoutSite", element: <CheckoutSite />, isPrivate: true },

  { path: "*", name: "NotFound", element: <NoRoute />, isPrivate: false },
  { path: "/login", name: "Login", element: <Login />, isPrivate: false },
  { path: "/", name: "Login", element: <Login />, isPrivate: false },
  { path: "/forget-pass", name: "ForgetPassword", element: <ForgetPass />, isPrivate: false },
  { path: "/checkout", name: "CheckoutSite", element: <CheckoutSite />, isPrivate: false },
  { path: "/signup-affiliate", name: "SignUpAffiliate", element: <SignUpAffiliate />, isPrivate: false },
];
